import { HttpService } from '@/data/http/http-service';
import { ExternalInfos } from '@/domain/external/entities/external.entity';
import { ExternalGateway } from '@/domain/external/gateway/external.gateway';
import { Status } from '@/domain/external-invitation/entities/external-invitation.entity';
import {
  getCalculateModeForScope,
  ProjectCalculateMode,
} from '@/domain/external-invitation/utils/calculate-mode/get-calculate-mode-for-scope';

import {
  calculateCo2ExternalDtoSchema,
  externalDtoSchema,
} from './external.dto.schema';
import { ExternalMapper } from './external.mapper';

export class ApiExternalHttpGateway implements ExternalGateway {
  private httpProject = new HttpService({
    baseURL: import.meta.env.VITE_API_PROJECT,
  });
  private httpImpact = new HttpService({
    baseURL: import.meta.env.VITE_API_IMPACT,
  });

  async getExternalInfos(code: string): Promise<ExternalInfos> {
    const url = `/ext-invitations/${code}`;
    const response = await this.httpProject.get(url, {
      includeAuthorization: false,
    });

    const result = externalDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      throw result.error;
    }
    const externalInfos = ExternalMapper.dtoToEntity(result.data);
    return externalInfos;
  }

  async updateExternalInvitation(
    externalInfos: ExternalInfos,
    status: Status,
    completion: number,
  ): Promise<void> {
    // pre-http call to get co2 score for this external-invitation
    const mode = getCalculateModeForScope(externalInfos);
    const co2ExternalScore = await this.runImpactCalculateCo2External(
      externalInfos.projectId,
      mode,
    );
    // then include score in data
    const url = `/invitations/${externalInfos.id}`;
    const data = {
      status: status,
      completion: completion,
      score: co2ExternalScore,
    };
    const response = await this.httpProject.patch(url, data);
    if (response.status === 200) {
      return;
    } else {
      throw 'error';
    }
  }

  async runImpactCalculateCo2External(
    projectId: number,
    mode?: ProjectCalculateMode,
  ): Promise<string> {
    const url = '/calculate/co2/external';
    const data = { projectId, mode };
    const response = await this.httpImpact.post(url, data);
    const result = calculateCo2ExternalDtoSchema.safeParse(response.data);
    if (result.success === false) {
      console.error(result.error);
      return '';
    }
    const scoreInNumber = result.data.score;
    return scoreInNumber.toString();
  }
}
